import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=687d179e&"
var script = {}
import style0 from "./Unauthorized.vue?vue&type=style&index=0&id=687d179e&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports